import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DefaultPaginationProps from "../../propInterfaces/defaultPaginationProps";
import PushNotificationDTO from "../../shared/dtos/pushNotificationDTO";
import { getPushNotifications } from "../../services/pushNotificationApi";
import dayjs from "dayjs";

export const initialState = {
  value: {
    pushNotifications: new Array<PushNotificationDTO>(),
    total: 0,
    take: 10,
  },
  loading: false,
};

export const pushNotificationsAsync = createAsyncThunk(
  "pushNotifications/",
  async ({ page, take }: DefaultPaginationProps) => {
    const response = await getPushNotifications({
      page,
      take,
    });
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    for (const notification of response.data) {
      if (!notification.scheduledAt) continue;

      const scheduledAt = notification.scheduledAt;
      notification.scheduledAt = dayjs
        .utc(scheduledAt)
        .tz(userTimezone)
        .format("DD-MM-YYYY HH:mm");
    }
    const pushNotificationsObject = {
      pushNotifications: response.data,
      total: response.total,
      take: take,
    };
    return pushNotificationsObject;
  },
);

export const pushNotificationsSlice = createSlice({
  name: "pushNotifications",
  initialState,
  reducers: {
    updatePushNotificationsValue: (state) => {
      state.value.pushNotifications = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(pushNotificationsAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(pushNotificationsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.value.pushNotifications = state.value.pushNotifications.concat(
          action.payload.pushNotifications,
        );
        state.value.total = action.payload.total;
      })
      .addCase(pushNotificationsAsync.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { updatePushNotificationsValue } = pushNotificationsSlice.actions;

export default pushNotificationsSlice.reducer;
